export default __webpack_public_path__ + "static/media/GLWCs.6f597f0b.png";